// extracted by mini-css-extract-plugin
module.exports = {"container":"loader_container__w7YKa","spin":"loader_spin__DBcUU","show":"loader_show__B9qlg"};